import {
  BulbOutlined,
  CalendarOutlined,
  CommentOutlined,
  FileTextOutlined,
  FormOutlined,
  SmileOutlined,
  TrophyOutlined,
} from '@ant-design/icons'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { PostType } from '@/generated/graphql'

import s from './icons.module.less'

interface PostTypeIconProps {
  type: PostType
  style?: any
  withText?: boolean
  onClick?: (type: PostType | 'AnniversaryCard' | 'All') => void
}

export const PostTypeIcon: React.FC<PostTypeIconProps> = ({ type, style, withText = false, onClick }) => {
  const { t } = useTranslation()

  const isChildrenDay = ['05-29', '05-30', '05-31', '06-01'].includes(moment().format('MM-DD'))
  const thanksIcon = isChildrenDay ? '🎈 ' : <SmileOutlined style={{ ...style }} />

  const thanksText = isChildrenDay ? t('post.thanks.sendBalloon') : t('post.thanks.thanks')

  const icon = {
    [PostType.Thanks]: thanksIcon,
    [PostType.Forum]: <CommentOutlined style={{ ...style }} />,
    [PostType.Journal]: <FormOutlined style={{ ...style }} />,
    [PostType.General]: <FileTextOutlined style={{ ...style }} />,
    [PostType.Event]: <CalendarOutlined style={{ ...style }} />,
    [PostType.Announcement]: <BulbOutlined style={{ ...style }} />,
    [PostType.Honor]: <TrophyOutlined style={{ ...style }} />,
    [PostType.Introduction]: null,
  }[type]

  const text =
    withText &&
    {
      [PostType.Thanks]: thanksText,
      [PostType.Forum]: t('post.forum.forum'),
      [PostType.Journal]: t('post.journal.name'),
      [PostType.General]: t('post.general') + t('post.post'),
      [PostType.Event]: t('post.event.name'),
      [PostType.Announcement]: t('post.announcement.name'),
      [PostType.Honor]: t('post.honor.name'),
      [PostType.Introduction]: null,
    }[type]

  return (
    <div style={{ cursor: onClick ? 'pointer' : undefined }} onClick={() => onClick && onClick(type)}>
      {icon}
      {withText && <span className={s.text}>{text}</span>}
    </div>
  )
}
